import { BreadcrumbItem, Breadcrumbs as BreadcrumbsWrapper } from '@heroui/react';
import { Home } from 'lucide-react';
import React, { FC } from 'react';
import {
  Link, useLocation,
  // useNavigate
} from 'react-router-dom';

import {
  // Back,
  BreadcrumbsContainer, Container,
} from './Breadcrumbs.styled';

export const Breadcrumbs:FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  // const navigate = useNavigate();
  return (
    <BreadcrumbsContainer>
      <Container>
        {/* <Back onClick={() => navigate(-1)}><StepBack size={20} strokeWidth={1.2} /></Back> */}
        <BreadcrumbsWrapper>

          <BreadcrumbItem>
            <Link to="/" className="flex items-center justify-center gap-2">
              <Home size={16} strokeWidth={1.2} className="position-relative mt-[-3px]" />
              Dashboard
            </Link>
          </BreadcrumbItem>
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const formatName = (str: string) :string => str
              .split('-')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');

            if (name !== 'dashboard') {
              return (
                <BreadcrumbItem key={name}>
                  <Link to={routeTo}>{formatName(name)}</Link>
                </BreadcrumbItem>
              );
            }
            return null;
          })}

        </BreadcrumbsWrapper>
      </Container>
    </BreadcrumbsContainer>
  );
};
